import { setDefaultOptions } from 'date-fns';
import { enUS } from 'date-fns/locale';
/**
 * Default date configuration instance with default values for en-US locale.
 */
export const defaultDateConfig = {
    dateFormat: 'P', // 04/29/1453
    dateTimeFormat: 'Pp', // 04/29/1453, 12:00 AM
    timeZone: undefined,
    formatOptions: {
        locale: enUS,
    },
};
/**
 * Changes default date configuration.
 * @param {DefaultDateConfig} dateConfig - New default configuration.
 */
export function setDefaultDateConfig(dateConfig) {
    Object.assign(defaultDateConfig, dateConfig);
    setDefaultOptions(dateConfig.formatOptions);
}
/**
 * Changes default date configuration to default.
 * Should be used in unit tests.
 */
export function resetDefaultDateConfig() {
    defaultDateConfig.dateFormat = 'P';
    defaultDateConfig.dateTimeFormat = 'Pp';
    delete defaultDateConfig.timeZone;
    defaultDateConfig.formatOptions = {
        locale: enUS,
    };
    setDefaultOptions(defaultDateConfig.formatOptions);
}
